// Left in place for backwards compatibility.  Import directly from @core/util instead.
module.exports = require('@core/util/clientlogger');



// WEBPACK FOOTER //
// /home/jenkins/agent/workspace/marketing-campaigns_deploy_trigger_ce_v2/package/node_modules/@component/common/src/util/Logger.js